import request from '@/utils/request'

/**
 * @apiName 维保退款订单列表
 */
export function getOrderRefundListApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/order/refund/list',
    method: 'POST',
    data,
  })
}
